/* SöMN 2026: carousel controls + sticky add to cart + reliable anchor links */
(function () {
  'use strict';

  function initCarousels(root) {
    (root || document).querySelectorAll('[data-somn-carousel]').forEach(function (wrap) {
      if (wrap.dataset.somnReady) return;
      wrap.dataset.somnReady = '1';
      var track = wrap.querySelector('[data-somn-track]');
      var prev = wrap.querySelector('[data-somn-prev]');
      var next = wrap.querySelector('[data-somn-next]');
      if (!track) return;
      function step() {
        var card = track.firstElementChild;
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        return card.getBoundingClientRect().width + gap;
      }
      function sync() {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 4;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight) && r.height > 0;
  }

  /* Shopify's theme preview bar sits on the bottom edge; lift the sticky bar above it so it stays visible in preview. */
  function previewBarOffset() {
    var pb = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
    if (!pb) return 0;
    var r = pb.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (r.height <= 0 || getComputedStyle(pb).display === 'none' || r.bottom < vh - 4) return 0;
    return Math.round(r.height);
  }

  function initSticky(el) {
    if (!el || el.dataset.somnReady) return;
    el.dataset.somnReady = '1';
    var mode = el.dataset.mode;
    var showOnAll = el.dataset.showOn === 'all';
    var target;
    var blockers = [];
    var lastShow = null;

    function render(show) {
      if (show === lastShow) return;
      lastShow = show;
      el.classList.toggle('is-visible', show);
      el.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) { el.removeAttribute('inert'); } else { el.setAttribute('inert', ''); }
    }

    function compute() {
      if (!target) return;
      var past = target.getBoundingClientRect().bottom < 0;
      var blocked = false;
      for (var i = 0; i < blockers.length; i++) { if (inView(blockers[i])) { blocked = true; break; } }
      var show = past && !blocked;
      var offset = previewBarOffset();
      el.style.bottom = offset ? offset + 'px' : '';
      render(show);
      var mobile = window.matchMedia('(max-width: 989px)').matches;
      document.body.classList.toggle('somn-sticky-shown', show && (mobile || showOnAll));
    }

    if (mode === 'product') {
      var main = document.querySelector('[id^="MainProduct-"]');
      if (!main) return;
      target = main.querySelector('product-form') || main;
      var addBtn = el.querySelector('[data-somn-sticky-add]');
      var addLabel = addBtn ? addBtn.querySelector('span') : null;
      var metaEl = el.querySelector('[data-somn-sticky-meta]');
      var priceEl = el.querySelector('[data-somn-sticky-price]');
      var variantsEl = el.querySelector('[data-somn-variants]');
      var variants = [];
      try { variants = JSON.parse(variantsEl ? variantsEl.textContent : '[]'); } catch (e) { variants = []; }
      var fmt = null;
      try { fmt = new Intl.NumberFormat(el.dataset.locale || 'en-US', { style: 'currency', currency: el.dataset.currency || 'USD' }); } catch (e) { fmt = null; }

      var update = function () {
        var input = main.querySelector('product-form input[name="id"]');
        var mainBtn = main.querySelector('button[name="add"]');
        var id = input ? String(input.value) : '';
        var v = null;
        for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === id) { v = variants[i]; break; } }
        if (v) {
          if (metaEl) metaEl.textContent = v.title.replace(/ \/ /g, ' · ');
          if (priceEl && fmt) priceEl.textContent = fmt.format(v.price / 100);
        }
        var unavailable = v ? !v.available : !!(mainBtn && mainBtn.disabled);
        if (addBtn) addBtn.disabled = unavailable;
        if (addLabel) addLabel.textContent = unavailable ? el.dataset.soldLabel : el.dataset.addLabel;
      };

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var mainBtn = main.querySelector('button[name="add"]');
          if (mainBtn && !mainBtn.disabled) { mainBtn.click(); }
          else { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        });
      }
      var chooser = el.querySelector('[data-somn-sticky-choose]');
      if (chooser) {
        chooser.addEventListener('click', function () {
          var picker = main.querySelector('variant-selects') || target;
          picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
      document.addEventListener('change', function () { window.setTimeout(update, 80); });
      try {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.variantChange, function () { window.setTimeout(update, 80); });
        }
      } catch (e) { /* noop */ }
      update();
    } else {
      target = document.querySelector(el.dataset.after || '.somn-hero') || document.querySelector('main .shopify-section');
      document.querySelectorAll('main product-form, .somn-sticky-blocker, footer').forEach(function (b) { blockers.push(b); });
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.setTimeout(function () { ticking = false; compute(); }, 60);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    compute();
    window.setTimeout(compute, 1500);
  }

  /* Links like /products/komforte#reviews: the theme and review app can reset the browser's jump while the page loads,
     so scroll to the target again once things settle, unless the visitor has already started scrolling. */
  function jumpToHash() {
    var id = '';
    try { id = decodeURIComponent((window.location.hash || '').slice(1)); } catch (e) { id = ''; }
    if (!id || !/^[A-Za-z][\w-]*$/.test(id)) return;
    var target = document.getElementById(id);
    if (!target) return;
    var userMoved = false;
    var stop = function () { userMoved = true; };
    window.addEventListener('wheel', stop, { passive: true, once: true });
    window.addEventListener('touchstart', stop, { passive: true, once: true });
    window.addEventListener('keydown', stop, { once: true });
    [50, 500, 1500, 3000].forEach(function (ms) {
      window.setTimeout(function () {
        if (userMoved) return;
        var top = target.getBoundingClientRect().top;
        if (Math.abs(top) > 40) target.scrollIntoView({ block: 'start' });
      }, ms);
    });
  }

  function init(root) {
    initCarousels(root);
    (root || document).querySelectorAll('[data-somn-sticky]').forEach(initSticky);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  if (document.readyState === 'complete') { jumpToHash(); } else { window.addEventListener('load', jumpToHash); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
